export { default } from './MiscCard';
